/**
 * List of all the errors
 * @description All the error messages which will be shown to the user if an error exists
 */
const errors = {
  common: {
    msg: "Something went wrong.",
  },
  // Password rules error messages
  password: {
    errorMessages: {
      passwordMisMatch:
        "Temporary password and Confirm Temporary password must match.",
      passwordInvalid: "Temporary password is not valid",
      currentPasswordInvalid:
        "Confirm Temporary password password is not valid",
      userDoesNotExists: "User does not exists.",
    },
  },
};

export default Object.freeze(errors);
